






























import { Component, Vue, Prop } from 'vue-property-decorator';

import { Quote, QuoteTerm } from '@/services/Quotes';
import { quoteProviderProcedures } from '../../components/Quotes/QuoteFilters';
import ClientDetails from '@/components/Broker/ClientDetails.vue';
import Alert from '@/components/Global/Alert.vue';
import AccordionList from '@/components/Global/Accordion/AccordionList.vue';
import Sidebar from '@/pages/Home/InsureCareTeams/InsureCareSideBar.vue';
import PolicyDocuments, { PolicyDocumentMetadata, PolicyPacket } from '@/services/PolicyDocuments';
import * as Sentry from '@sentry/browser';
import Loading from '@/components/Global/Loading.vue';
@Component({
     name: 'BrokerClientDetails',
     components: {
          ClientDetails,
          Alert,
          AccordionList,
          Sidebar,
          Loading,
     },
})
export default class BrokerClientDetails extends Vue {
     @Prop() public clientProp: any;
     private clients: any = [];
     private error: boolean = false;
     private loading: boolean = true;
     private async created() {
          const client: any = this.$route.params.client;
          try {
               const policyDocumentMetaData: PolicyDocumentMetadata[] =
                    await PolicyDocuments.getPolicyDocumentMetadatas(
                         client.policy_number,
                    );
               if (policyDocumentMetaData.length === 0) {
                    throw new Error('No policy documents were successfully fetched');
               }
               client.packet = PolicyDocuments.packetizePolicyDocumentMetadatas(
                    policyDocumentMetaData,
               )[0];
               this.clients.push(client);
          } catch (error) {
               // Sentry.captureException(error);
               this.error = true;
          } finally {
               this.loading = false;
          }
     }
}
